function normalizeError(text: string) {
  if (text.startsWith('Network error: ')) {
    return 'Network Error';
  }
  return text.replace('GraphQL error: ', '');
}

export { normalizeError };
